export default "__VITE_ASSET__Bz6IiEO3__"